export default {
  LOG_EVENT_CODE_ADD_USER: 'Add User',
  LOG_EVENT_CODE_MODIFY_USER: 'Modify User',
  LOG_EVENT_CODE_DELETE_USER: 'Delete User',
  LOG_EVENT_CODE_LOCK_USER: 'Lock User',
  LOG_EVENT_CODE_UNLOCK_USER: 'Unlock User',
  LOG_EVENT_CODE_RESET_PASSWORD: 'Reset Password',
  LOG_EVENT_CODE_CHANGE_PASSWORD: 'Change Password',
  LOG_EVENT_CODE_MODIFY_COMPANY_INFO: 'Modify Company Information',
  LOG_EVENT_CODE_ORDER: 'Order',
  LOG_EVENT_CODE_ADD_ORDER_OFFER: 'Add Offer',
  LOG_EVENT_CODE_DELETE_ORDER_OFFER: 'Deactivate Offer',
  LOG_EVENT_CODE_ORDER_PAYMENT: 'Payment Order',
  LOG_EVENT_CODE_CANCEL_ORDER: 'Cancel Order',
  LOG_EVENT_CODE_MEMBER: 'Member',
  LOG_EVENT_CODE_MEMBER_BLOCK: 'Block Member',
  LOG_EVENT_CODE_MEMBER_UNBLOCK: 'Reactivation Member',
  LOG_EVENT_CODE_CHANGE_MEMBER_ROLE: 'Change Member Role',
  LOG_EVENT_CODE_MIGRATE_ACCOUNT: 'Migrate Account',
  LOG_EVENT_CODE_CHANGE_ACCOUNT: 'Modify Account',
  LOG_EVENT_CODE_BALANCE_TRANSFER: 'Balance Transfer',
  LOG_EVENT_CODE_BLACK_AND_WHITE: 'Blacklist and Whitelist',
  LOG_EVENT_CODE_ADD_BLACKLIST: 'Add Blacklist',
  LOG_EVENT_CODE_DELETE_BLACKLIST: 'Delete Blacklist',
  LOG_EVENT_CODE_ADD_WHITELIST: 'Add Whitelist',
  LOG_EVENT_CODE_DELETE_WHITELIST: 'Delete Whitelist',
  LOG_EVENT_CODE_ADD_BLACKLIST_MEMBER: 'Add Blacklist Member',
  LOG_EVENT_CODE_DELETE_BLACKLIST_MEMBER: 'Delete Blacklist Member',
  LOG_EVENT_CODE_ADD_WHITELIST_MEMBER: 'Add Whitelist Member',
  LOG_EVENT_CODE_DELETE_WHITELIST_MEMBER: 'Delete Whitelist Member',
  LOG_EVENT_CODE_ROLE: 'Role',
  LOG_EVENT_CODE_ADD_ROLE: 'Add Role',
  LOG_EVENT_CODE_DELETE_ROLE: 'Delete Role',
  LOG_EVENT_CODE_CHANGE_ROLE: 'Modify Role',
  LOG_EVENT_CODE_GROUP: 'Group',
  LOG_EVENT_CODE_JOIN_CUG: 'Join CUG',
  LOG_EVENT_CODE_QUIT_CUG: 'Quit CUG',
  LOG_EVENT_CODE_ADD_FREQUENT_NUMBER: 'Add Frequent Number',
  LOG_EVENT_CODE_DELETE_FREQUENT_NUMBER: 'Delete Frequent Number',
  LOG_EVENT_CODE_CHANGE_FREQUENT_NUMBER: 'Modify Frequent Number',
  LOG_EVENT_CODE_SEND_SMS: 'Send SMS',
  LOG_EVENT_CODE_SEND_EMAIL: 'Send Email',
  LOG_EVENT_CODE_SYSTEM: 'System',
  LOG_EVENT_CODE_DOWNLOAD_BILL: 'Download Bill',
  LOG_EVENT_CODE_DOWNLOAD_USAGE: 'Download Usage',
  LOG_EVENT_CODE_MODIFY_BLACKLIST: 'Modify Blacklist',
  LOG_EVENT_CODE_MODIFY_WHITELIST: 'Modify Whitelist',
  LOG_EVENT_CODE_ADD_OUTGOING_LOCATION_RESTRICTION_INST:
    'Add Outgoing Location Restriction Inst',
  LOG_EVENT_CODE_ADD_CALLING_LOCATION_RESTRICTION_INST:
    'Add Calling Location Restriction Inst',
  LOG_EVENT_CODE_ADD_BILLING_LOCATION_RESTRICTION_INST:
    'Add Billing Location Restriction Inst',
  LOG_EVENT_CODE_MODIFY_OUTGOING_LOCATION_RESTRICTION_INST:
    'Modify Outgoing Location Restriction Inst',
  LOG_EVENT_CODE_MODIFY_CALLING_LOCATION_RESTRICTION_INST:
    'Modify Calling Location Restriction Inst',
  LOG_EVENT_CODE_MODIFY_BILLING_LOCATION_RESTRICTION_INST:
    'Modify Billing Location Restriction Inst',
  LOG_EVENT_CODE_DELETE_OUTGOING_LOCATION_RESTRICTION_INST:
    'Delete Outgoing Location Restriction Inst',
  LOG_EVENT_CODE_DELETE_CALLING_LOCATION_RESTRICTION_INST:
    'Delete Calling Location Restriction Inst',
  LOG_EVENT_CODE_DELETE_BILLING_LOCATION_RESTRICTION_INST:
    'Delete Billing Location Restriction Inst',
  LOG_EVENT_CODE_ADD_OUTGOING_LOCATION_RESTRICTION_INST_ITEM:
    'Add Outgoing Location Restriction Region',
  LOG_EVENT_CODE_ADD_CALLING_LOCATION_RESTRICTION_INST_ITEM:
    'Add Calling Location Restriction Region',
  LOG_EVENT_CODE_DELETE_OUTGOING_LOCATION_RESTRICTION_INST_ITEM:
    'Delete Outgoing Location Restriction Region',
  LOG_EVENT_CODE_DELETE_CALLING_LOCATION_RESTRICTION_INST_ITEM:
    'Delete Calling Location Restriction Region',
  LOG_EVENT_CODE_DELETE_BILLING_LOCATION_RESTRICTION_INST_ITEM:
    'Delete Billing Location Restriction Region',
  LOG_EVENT_CODE_BATCH_BLOCK_VAS: 'Batch Block Vas',
  LOG_EVENT_CODE_BATCH_UNBLOCK_VAS: 'Batch Unblock Vas',
  LOG_EVENT_CODE_RESET_DEFAULT_PASSWORD: 'Reset Default PassWord',
  LOG_EVENT_CODE_FORCE_LOGOUT: 'Force Logout',
  LOG_EVENT_CODE_SUSPEND_CUG: 'Suspend CUG',
  LOG_EVENT_CODE_REACTIVE_CUG: 'Reactive CUG',
  LOG_EVENT_CODE_TRANSFER_CUG_MEMBER: 'Transfer CUG Member',
  LOG_EVENT_CODE_CHANGE_CUG_NAME: 'Change CUG Name',
  LOG_EVENT_CODE_CHANGE_SUBSPLAN_CUG: 'Change Subsplan CUG',
  LOG_EVENT_CODE_ERMINATE_CUG: 'Erminate CUG',
  LOG_EVENT_CODE_CREATE_TICKET: 'Create Ticket',
  LOG_EVENT_CODE_CREATE_FAQ_CATEGORY: 'Create FAQ Category',
  LOG_EVENT_CODE_CREATE_FAQ_CONTENT: 'Create FAQ Content',
  LOG_EVENT_CODE_UPDATE_FAQ_CONTENT: 'Update FAQ Content',
  LOG_EVENT_CODE_PUBLISH_FAQ: 'Publish FAQ',
  LOG_EVENT_CODE_DELETE_FAQ: 'Delete FAQ',
  LOG_EVENT_CODE_DELETE_FAQ_CATEGORY: 'Delete FAQ Category',
  LOG_EVENT_CODE_MODIFY_VAS: 'Modify VAS',
  LOG_EVENT_CODE_CHECK_MEMBER_BATCH_SUSPEND_AND_REACTIVE:
    'Check Member Batch Suspend And Reactive',
  LOG_EVENT_CODE_MEMBER_BATCH_SUSPEND: 'Member Batch Suspend',
  LOG_EVENT_CODE_MEMBER_BATCH_REACTIVE: 'Member Batch Reactive',
  LOG_EVENT_CODE_BATCH_TRANSFER_DEPARTMENT: 'Batch Transfer Department',
  LOG_EVENT_CODE_MEMBER_MODIFY_LANG: 'Member Modify Language',
  LOG_EVENT_CODE_MODIFY_CREDITLIMIT: 'Modify Credit Limit',
  LOG_EVENT_CODE_QUERY_ORDER_LIST: 'Query Order List',
  LOG_EVENT_CODE_QUERY_ORDER_DETAIL: 'Query Order Detail',
  LOG_EVENT_CODE_CHANGE_SUBS_PLAN: 'Change Subsplan',
  LOG_EVENT_CODE_ADD_CUST_ORDER_ATTACH: 'Add Customer Order Attach',
  LOG_EVENT_CODE_CREATE_ACCOUNT: 'Create Account',
  LOG_EVENT_CODE_CREATE_DEPARTMENT: 'Create Department',
  LOG_EVENT_CODE_MODIFY_DEPARTMENT: 'Modify Department',
  LOG_EVENT_CODE_DELETE_DEPARTMENT: 'Delete Department',
  LOG_EVENT_CODE_ADD_MEMBER: 'Add Member',
  LOG_EVENT_CODE_DELETE_MEMBER: 'Delete Member',
  LOG_EVENT_CODE_TRANSFER_MEMBER: 'Transfer Member',
  LOG_EVENT_CODE_NUMBER_SHIFTING: 'Number Shifting',
  LOG_EVENT_CODE_OPERATE_CUG: 'Operate CUG',
  LOG_EVENT_CODE_CHANGE_SIM_CARD: 'Change SIM Card',
  LOG_EVENT_CODE_NEW_CONNECTION: 'New Connection',
  LOG_EVENT_CODE_FORGET_PASSWORD: 'Forget PassWord',
  LOGIN_FAILURE: 'Login Failure',
  'systemLog.eventCode': 'Event',
  'systemLog.logDate': 'Log Date',
  'systemLog.beginDate': 'Begin Date',
  'systemLog.endDate': 'End Date',
  'systemLog.userCode': 'User Code',
  'systemLog.validDate': 'Start Date must not be earlier than the end date',
  LOG_EVENT_CODE_EDIT_COMMENTS: 'Edit Comments',
  LOG_EVENT_CODE_CHANGE_BUNDLE_OFFER: 'Change Bundle Offer',
  LOG_EVENT_CODE_RELOCATION: 'Relocation',
  LOG_EVENT_CODE_ADD_BALANCE_SHARE: 'Add Balance Share',
  LOG_EVENT_CODE_MOD_BALANCE_SHARE: 'Modify Balance Share',
  LOG_EVENT_CODE_DELETE_BALANCE_SHARE: 'Delete Balance Share'
};
